<section
  class="employee-basket-card employee-basket-cart-management"
  [style.border-color]="statusColor()"
>
  <mat-expansion-panel
    class="employee-basket-cart-management__panel"
    [expanded]="expanded()"
    (expandedChange)="expanded.set($event)"
  >
    <mat-expansion-panel-header>
      <mat-panel-title class="employee-basket-cart-management__header">
        <mat-icon class="employee-basket-cart-management__icon" [style.color]="wls.warnColor">
          shopping_cart
        </mat-icon>
        <div class="employee-basket-cart-management__title-group">
          <span class="employee-basket-cart-management__title">
            {{ cartDisplayName() }}
          </span>
          @if (isOutsideChoicePeriod()) {
            <span class="employee-basket-cart-management__period-hint">
              {{ 'employee.basket.outside-of-choice-period' | translate }}
            </span>
          }
        </div>
        <span class="employee-basket-cart-management__status" [style.color]="statusColor()">
          {{ statusTranslationKey() | translate | uppercase }}
        </span>
      </mat-panel-title>
    </mat-expansion-panel-header>

    @for (section of sections(); track section.kind; let isFirst = $first) {
      <div class="employee-basket-cart-management__group">
        <div class="employee-basket-cart-management__group-header">
          <mat-icon class="employee-basket-card__dot" [style.color]="sectionDotColor(section)"
            >lens</mat-icon
          >
          <span>{{ section.titleKey | translate }}</span>
          <span
            class="employee-basket-cart-management__count"
            [style.background-color]="sectionCountBackgroundColor(section)"
            [style.color]="sectionCountTextColor(section)"
          >
            {{ section.benefits.length }}
          </span>
          @if (isFirst) {
            <div class="employee-basket-cart-management__amount-header">
              @if (isPbEnabled()) {
                <span
                  class="employee-basket-cart-management__column-title"
                  [style.color]="wls.accentColor"
                  >{{ 'employee.basket.badge-pb' | translate }}</span
                >
              }
              @if (isSsEnabled()) {
                <span
                  class="employee-basket-cart-management__column-title"
                  [style.color]="wls.warnColor"
                  >{{ 'employee.basket.sacrifice-yearly' | translate }}</span
                >
              }
              @if (section.showRemove) {
                <span
                  aria-hidden="true"
                  class="employee-basket-cart-management__actions-spacer"
                ></span>
              }
            </div>
          }
        </div>
        @for (benefit of section.benefits; track benefit.id) {
          <flexyoo-employee-basket-cart-management-row
            [benefit]="benefit"
            [isSelected]="benefit.id === selectedBenefitId()"
            [showPb]="!!isPbEnabled()"
            [showRemove]="section.showRemove"
            [showReuploadWarning]="section.showReuploadWarning"
            [showSs]="!!isSsEnabled()"
            (open)="onOpenBenefit($event)"
            (remove)="onRemoveBenefit($event)"
            (reupload)="onOpenBenefit($event)"
          />
        }
      </div>
    }

    <div class="employee-basket-cart-management__summary">
      <div class="employee-basket-cart-management__group-header">
        <mat-icon class="employee-basket-card__dot" [style.color]="wls.accentColor">lens</mat-icon>
        <span>{{ 'employee.basket.summary' | translate }}</span>
      </div>

      <div class="employee-basket-cart-management__summary-table">
        <div class="employee-basket-cart-management__summary-head">
          <span></span>
          @if (isPbEnabled()) {
            <span
              class="employee-basket-cart-management__column-title"
              [style.color]="wls.accentColor"
              >{{ 'employee.basket.selected-pb' | translate }}</span
            >
          }
          @if (isSsEnabled()) {
            <span
              class="employee-basket-cart-management__column-title"
              [style.color]="wls.warnColor"
              >{{ 'employee.basket.sacrifice-total' | translate }}</span
            >
          }
        </div>
        <div class="employee-basket-cart-management__summary-row">
          <span class="employee-basket-cart-management__summary-row-title">{{
            'employee.basket.selected-amount' | translate
          }}</span>
          @if (isPbEnabled()) {
            <span>{{ summary().pbSelected | flexyooNumber }}</span>
          }
          @if (isSsEnabled()) {
            <span>{{ summary().ssSelected | flexyooNumber }}</span>
          }
        </div>
      </div>

      <button
        class="employee-basket-cart-management__simulation"
        matButton="outlined"
        type="button"
        (click)="onOpenFinancialImpactReport()"
      >
        {{ 'employee.basket.show-detailed-simulation' | translate }}
      </button>
    </div>

    @if (showFooterActions()) {
      <div class="employee-basket-cart-management__footer">
        @if (presentation().showClearBasket) {
          <span
            class="employee-basket-cart-management__clear-basket"
            [matTooltip]="
              isClearBasketDisabled()
                ? ('employee.basket.clear-basket-disabled-tooltip' | translate)
                : ''
            "
            [matTooltipDisabled]="!isClearBasketDisabled()"
          >
            <button
              class="fo-color-error"
              matButton="filled"
              type="button"
              [disabled]="isClearBasketDisabled()"
              (click)="onClearCart()"
            >
              {{ 'employee.basket.clear-basket' | translate }}
            </button>
          </span>
        }
        @if (presentation().showConfirmAndSign || presentation().showConfirmAndResign) {
          <span
            [matTooltip]="
              presentation().isConfirmAndSignDisabled
                ? ('employee.basket.confirm-and-sign-disabled-tooltip' | translate)
                : ''
            "
            [matTooltipDisabled]="!presentation().isConfirmAndSignDisabled"
          >
            <button
              matButton="filled"
              type="button"
              [class.employee-basket-cart-management__confirm--impersonate]="
                presentation().kind === 'signature-rejected'
              "
              [class.fo-color-error]="
                presentation().showConfirmAndResign && presentation().kind !== 'signature-rejected'
              "
              [disabled]="isConfirmAndSignDisabled()"
              (click)="onSignCart()"
            >
              {{
                (presentation().showConfirmAndResign
                  ? 'employee.basket.confirm-and-resign'
                  : 'employee.basket.confirm-and-sign'
                ) | translate
              }}
            </button>
          </span>
        }
      </div>
    }
  </mat-expansion-panel>
</section>
